import { Container } from "@/components/layout/Container";
import s from "./SectionPromo.module.scss";
import { SearchForm } from "@/components/forms/SearchForm";
import { Heading } from "@/components/UI/typography/Heading";

export const SectionPromo = () => {
  return (
    <section className={s.sectionPromo}>
      <Container className={s.container}>
        <Heading level={1} className={s.heading}>
          <span>Unleashing creativity</span> with our free essay collection
        </Heading>
        <p className={s.subheading}>
          At StudyBounty, we provide complimentary access to an extensive collection of essay samples.
          Designed to inspire and guide students from high school to university level, our resources can
          ignite your creativity and refine your writing skills. Dive in today and unlock a world of academic
          inspiration.
        </p>
        <SearchForm />
      </Container>
    </section>
  );
};
